import { atom, useAtomValue, useSetAtom } from "jotai";

export const purchaseDetailsModal = atom ( {
	open    : false,
	orderId : undefined
} );

/**
 * @type {any} UserPlan Atom
 */
export const userPlanAtom = atom ( null );
export const managePlanAtom = atom ( false );

export const useGetUserPlan = () => useAtomValue ( userPlanAtom );
export const useSetUserPlan = () => useSetAtom ( userPlanAtom );

export const useGetManageSubscriptionPlan = () => useAtomValue ( managePlanAtom );
export const useSetManageSubscriptionPlan = () => useSetAtom ( managePlanAtom );

export const useGetPurchaseDetailsModal = () => useAtomValue ( purchaseDetailsModal );
export const useSetPurchaseDetailsModal = () => useSetAtom ( purchaseDetailsModal );
